/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import Modal2 from 'components/modals/Modal2/Modal2';
import { useIntl } from 'react-intl';
import styles from './style.cssmodule.css';

function ModalHowItWorks() {
  const [howItWorksModalOpen, setHowItWorksModalOpen] = React.useState(false);
  const { formatMessage: t } = useIntl();

  return (
    <React.Fragment>
      <li onClick={() => setHowItWorksModalOpen(true)}>{t({ id: 'button.howFlowWork' })}</li>
      <Modal2
        isOpen={howItWorksModalOpen}
        size="large"
        onClose={() => setHowItWorksModalOpen(false)}
        title={t({ id: 'info.howWork' })}
        modalType="info"
        actions={[
          {
            label: 'button.close',
            onClick: () => setHowItWorksModalOpen(false),
          },
        ]}
      >
        <div className={styles.howItWorksGrid}>
          <div className={styles.stepLeft}>
            <div className={styles.stepCircle}>1</div>
            <div className={styles.verticalBar} />
          </div>
          <div className={styles.stepRight}>
            <h5 className={styles.stepTitle}>{t({ id: 'step' }, { step: 1 })}</h5>
            <p className={styles.stepContent}>
              {t({
                id: 'info.howWork.text1',
              })}
            </p>
          </div>

          <div className={styles.stepLeft}>
            <div className={styles.stepCircle}>2</div>
            <div className={styles.verticalBar} />
          </div>
          <div className={styles.stepRight}>
            <h5 className={styles.stepTitle}>{t({ id: 'step' }, { step: 2 })}</h5>
            <p className={styles.stepContent}>{t({ id: 'info.howWork.text2' })}</p>
          </div>

          <div className={styles.stepLeft}>
            <div className={styles.stepCircle}>3</div>
          </div>
          <div className={styles.stepRight}>
            <h5 className={styles.stepTitle}>{t({ id: 'step' }, { step: 3 })}</h5>
            <p className={styles.stepContent}>
              {t({ id: 'info.howWork.text3' })}
              <ul>
                <li>{t({ id: 'info.howWork.text3.option1' })}</li>
                <li>{t({ id: 'info.howWork.text3.option2' })}</li>
              </ul>
            </p>
          </div>
        </div>
      </Modal2>
    </React.Fragment>
  );
}

export default ModalHowItWorks;



// WEBPACK FOOTER //
// ./components/templates/AuthenticationLayout/components/ModalHowItWorks/ModalHowItWorks.jsx